<template>
  <div class="flex items-center space-x-4">
    <user-avatar v-if="details && !photoPreview" :user="details" :size="14" />
    <div v-else>
      <img
        class="relative z-30 inline-block rounded-full ring-2 ring-white w-14 h-14 object-cover"
        v-if="photoPreview"
        :src="photoPreview"
        alt=""
      />
      <div
        v-else-if="placeholder"
        class="h-14 w-14 flex-shrink-0 rounded-full bg-gray-300 p-2 text-white grid place-items-center"
      >
        <component class="w-8 h" :is="placeholder" />
      </div>
      <span v-else>Anon</span>
    </div>

    <input
      type="file"
      accept="image/*"
      ref="imageInput"
      @input="handleImagesSelected"
      hidden
      :disabled="disabled"
    />
    <div>
      <button
        :disabled="disabled"
        class="rounded-md border border-gray-300 bg-white px-2.5 py-2 text-base font-medium text-gray-700 shadow-sm sm:w-auto sm:text-sm disabled:opacity-50"
        :class="{
          '!cursor-not-allowed': disabled,
          'hover:text-gray-500 focus:outline-none': !disabled,
        }"
        @click="handleImageSelectorOpened"
      >
        {{ t("components.buttons.change") }}
      </button>
    </div>
  </div>
</template>

<script setup>
import { computed, ref } from "vue";
import UserAvatar from "@/Tailwind/Components/UserAvatar";
import { useI18n } from "vue-i18n";

defineProps({
  details: Object,
  disabled: Boolean,
  placeholder: Object,
});

const emit = defineEmits(["file"]);

const { t } = useI18n();

const imageInput = ref();
const photo = ref(null);
const photoPreview = computed(() => {
  if (photo.value === null) {
    return;
  }

  return URL.createObjectURL(photo.value);
});

function handleImageSelectorOpened() {
  imageInput.value.click();
}

function handleImagesSelected(e) {
  const files = e.target.files;

  if (files.length === 0) {
    return;
  }

  const [file] = files;

  photo.value = file;
  emit("file", file);
}
</script>
